<!--
 * @Author: your name
 * @Date: 2021-01-28 17:44:28
 * @LastEditTime: 2021-03-09 09:18:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\FileManagement.vue
-->
<template>
  <div id='fileManagement'>
    <!-- 协会管理员 -->
    <el-row class="goBackHome" v-if="(roleType==2&&$parent.tabIndex==7)||(roleType==3&&$parent.tabIndex==7)">
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <span class="clickBack" @click="$parent.tabIndex=0"><img src="@/assets/img/back.png" alt="">返回</span>
      </el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <span style="color: #333333;" v-if="roleType==2">我的工作台 > </span>
        <span style="color: #333333;" v-if="roleType==3">我的申请 > </span>
        {{quesNaireData.applyName}}
      </el-col>
    </el-row>
    <template v-if="quesNaireData">
      <el-row class="quesStartInfo" v-if="(quesNaireData.recipientPerson==null||quesNaireData.recipientPerson==''||quesNaireData.recipientPerson==userId)&&roleType==2&&quesNaireData.applyStatus!=5&&quesNaireData.applyStatus!=4">
        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" class="applyColor">
          <el-row style="margin-bottom:10px;">
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
              公司名 :
              <span class="leftMargin">{{quesNaireData.companyName}}</span>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
              发起时间 :
              <span class="leftPadding">{{quesNaireData.createTime.substr(0,10)}}</span>
            </el-col>
          </el-row>
          <el-row>
            申请内容 : <span class="leftPadding"> {{quesNaireData.applyName}}
            </span>
          </el-row>
        </el-col>
        <template v-if="quesNaireData.taskStatus==2">
          <el-col class=" taskBack" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <div @click="taskBack">
              任务退回
              <img src="@/assets/img/任务退回.png" alt="">
            </div>
          </el-col>
          <el-col style="text-align:right;margin-right:20px;" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <el-button class="button add esc" style="margin-bottom:0px;" @click="$refs.ExamineDialog.isSuccess(5)">同意</el-button>
            <el-button class="button esc" style="margin-bottom:0px;" @click="$refs.ExamineDialog.applyVisible=true">拒绝</el-button>
          </el-col>
        </template>
        <template v-if="quesNaireData.taskStatus==1">
          <el-col class="receiveTask" :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
            <el-button class="button receive" @click="acceptTask">接受任务</el-button>
          </el-col>
        </template>
      </el-row>
      <el-row class="applyReason" v-if="roleType == 2 && $route.name == 'AdminApplication'&&remarkReason.length>0">
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">原因说明：</el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">{{remarkReason}}</el-col>
      </el-row>
    </template>
    <el-row class="fileTitle">
      <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
        <template v-if="(roleType==3||roleType==2)&&$route.name=='Management'">
          <h3>
            文件管理<span class="required-tips" v-if="roleType == 3">（必填）</span>
            <span v-if="roleType==3" class="fileTips">
              暂不支持上传多个文件，请将多个文件打包成一个文件上传
            </span>
            <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="remark">
          </h3>
        </template>
        <template v-if="(roleType==2&&$route.name=='AdminApplication')||(roleType==3&&$route.name=='Application')">
          <h3>{{quesNaireData.applyName}}</h3>
        </template>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-row class="fileEdit" v-if="roleType==3&&$route.name=='Management'">
          <el-button class="editFile" :disabled="isEdit" :class="{edit:isEdit1}" @click="editFileInfo">编辑</el-button>
          <el-button class="submitFile" :disabled="isSave" :class="{edit:isEdit2}" @click="saveFileInfo">保存并提交</el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-divider class="fileDivider"></el-divider>
    <div style="text-align:center;" v-if="isShowFile" class="no-file-result">
      <img src="@/assets/img/no-fileresult.png" alt="">
      暂无文件！
    </div>
    <template v-else>
      <el-row class="statusStyle" v-if="fileData!=null&&roleType==3&&(fileData.approveStatus==1)">
        <i class="el-icon-warning fileIcon"></i>
        <span v-if="fileData.approveStatus==1">申请添加中，请耐心等待管理员审批</span>
        <!-- <span v-if="fileData.approveStatus==2">申请修改中，请耐心等待管理员审批</span> -->
      </el-row>
      <!-- 申请修改的时候只显示提示文字，不显示具体 -->
      <div v-if="fileData!=null&&fileData.approveStatus==2">
        <div class="apply-change-tip">
          <img src="@/assets/img/applying.png" alt="">
          <span>申请修改已提交，请耐心等待管理员审批</span>
        </div>
      </div>
      <div v-else>
        <el-row class="fileUpload">
          <el-col class="name" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">营业执照：</el-col>
          <el-col class="picture" :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
            <el-upload ref="uploadFile" :class="{uploadNone:(roleType==2&&($route.name=='AdminApplication'||$route.name=='Management'))||(roleType==3&&$route.name=='Application')?true:false}" :headers="headerObj" :action="uploadUrl" :file-list="fileList1" :on-preview="handlePreview" :on-success="handleFileSuccess1" :on-remove="handleRemove1" :limit="1" :disabled="isFile">
              <el-button class="upload" :class="{escUpload:isUpload}">
                <i class="el-icon-upload2"></i>点击上传
              </el-button>
              <!-- <span slot="tip" class="el-upload__tip">（只能上传jpg/png文件，且不超过500kb）</span> -->
            </el-upload>
            <!-- <div class="progress" :style="{backgroundImage:'linear-gradient(to right,#C0C7CB 0%,#C0C7CB '+progress+',#E1E6E9 '+progress+',#E1E6E9 100%)'}">
            </div> -->
          </el-col>
        </el-row>
        <el-row class="fileUpload">
          <el-col class="name" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">合规文件：</el-col>
          <el-col class="picture" :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
            <el-upload ref="uploadFile" :class="{uploadNone:(roleType==2&&($route.name=='AdminApplication'||$route.name=='Management'))||(roleType==3&&$route.name=='Application')?true:false}" :headers="headerObj" :action="uploadUrl" :file-list="fileList2" :on-preview="handlePreview" :on-success="handleFileSuccess2" :disabled="isFile" :limit="1" :on-remove="handleRemove2">
              <el-button class="upload" :class="{escUpload:isUpload}">
                <i class="el-icon-upload2"></i>点击上传
              </el-button>
              <!-- <span slot="tip" class="el-upload__tip">（只能上传jpg/png文件，且不超过500kb）</span> -->
              <el-link slot="tip" class="el-upload__tip linkStyle example" :href="`${publicPath}file/企业信用报告.png`" download="企业信用报告.png" v-if="roleType==3">样例下载</el-link>
            </el-upload>
          </el-col>
        </el-row>
        <!-- <el-row class="fileUpload">
          <el-col class="name" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">高管资质：</el-col>
          <el-col class="picture" :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
            <el-upload ref="uploadFile" :class="{uploadNone:(roleType==2&&($route.name=='AdminApplication'||$route.name=='Management'))||(roleType==3&&$route.name=='Application')?true:false}" :headers="headerObj" :action="uploadUrl" :file-list="fileList3" :on-preview="handlePreview" :on-success="handleFileSuccess3" :disabled="isFile" :limit="1" :on-remove="handleRemove3">
              <el-button class="upload" :class="{escUpload:isUpload}">
                <i class="el-icon-upload2"></i>点击上传
              </el-button>
              <el-link slot="tip" class="el-upload__tip linkStyle example" :href="`${publicPath}file/企业负责人信用报告.png`" download="企业负责人信用报告.png" v-if="roleType==3">样例下载</el-link>
            </el-upload>
          </el-col>
        </el-row> -->
        <el-row class="fileUpload">
          <el-col class="name" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">其他文件：</el-col>
          <el-col class="picture" :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
            <el-upload ref="uploadFile" :class="{uploadNone:(roleType==2&&($route.name=='AdminApplication'||$route.name=='Management'))||(roleType==3&&$route.name=='Application')?true:false}" :headers="headerObj" :action="uploadUrl" :file-list="fileList4" :on-preview="handlePreview" :on-success="handleFileSuccess4" :disabled="isFile" :limit="1" :on-remove="handleRemove4">
              <el-button class="upload" :class="{escUpload:isUpload}">
                <i class="el-icon-upload2"></i>点击上传
              </el-button>
              <!-- <span slot="tip" class="el-upload__tip">（只能上传jpg/png文件，且不超过500kb）</span> -->
            </el-upload>
          </el-col>
        </el-row>
      </div>

    </template>
    <!-- 审批同意拒绝对话框 -->
    <ExamineDialog ref="ExamineDialog" />
    <!-- 任务退回对话框 -->
    <BackDialog ref="BackDialog" />
    <!-- 申请原因对话框 -->
    <ReasonDialog ref="reasonDialog" />
  </div>
</template>
<script>
import { addFileInfo, findFileInfo, taskManagement } from '@/api/index'
import ExamineDialog from '@/views/Home/common/ExamineDialog'
import BackDialog from '@/views/Home/common/BackDialog.vue'
import ReasonDialog from '@/components/ReasonDialog.vue'

export default {
  props: ['quesNaireData'],
  data() {
    return {
      name: 'FileManagement',
      roleType: window.sessionStorage.getItem('roleType'),
      userId: sessionStorage.getItem('userId'),
      publicPath: process.env.BASE_URL,  //模板路径
      isShowFile: false,
      isFile: false,
      isSave: false,
      isEdit: true,
      isUpload: true, //文件是否上传
      isEdit1: false,
      isEdit2: true,
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileData: {},
      fileParams: {
        id: '',
        businessLicense: "",
        complianceDocuments: "",
        executiveQualification: "",
        otherDocuments: "",
        remark: ""
      },
      headerObj: { token: window.sessionStorage.getItem('token') },
      uploadUrl: '', // 单文件
      uploadUrls: '', // 多文件
      progress: '',
      show: false,
      remarkReason: ""
    }
  },
  created() {
    this.uploadUrl = this.$http.defaults.baseURL + 'user/uploadFile'
    this.uploadUrls = this.$http.defaults.baseURL + 'user/uploadFiles'
    this.getFileInfo()
    
  },
  methods: {
    handlePreview(param){
      if(param.url){
        window.open(param.url)
      }
    },
    // five() {
    //   // $children[7].isSuccess(5)
    // },
    remark() {
      this.$parent.$parent.$parent.$parent.findRemark(5)
    },
    // 任务退回
    taskBack() {
      this.$refs.BackDialog.titleName = '任务退回'
      this.$refs.BackDialog.refuseVisible = true
      this.$refs.BackDialog.step = 1
      this.$refs.BackDialog.receiveParams.id = this.quesNaireData.id
    },
    // 接受任务
    async acceptTask() {
      this.$refs.BackDialog.receiveParams.id = this.quesNaireData.id
      this.$refs.BackDialog.receiveParams.taskStatus = 2
      const { data } = await taskManagement(this.$refs.BackDialog.receiveParams)
      if (data.code != 0) return
      this.quesNaireData.taskStatus = 2
      this.$parent.findAllTask()
    },
    async getFileInfo() {
      if ((this.roleType == 2 && this.$route.name == 'AdminApplication') || (this.roleType == 3 && this.$route.name == 'Application')) {
        this.fileData = JSON.parse(this.quesNaireData.param)
        this.fileList1 = JSON.parse(this.fileData.businessLicense)
        this.fileList2 = JSON.parse(this.fileData.complianceDocuments)
        this.fileList3 = JSON.parse(this.fileData.executiveQualification)
        this.fileList4 = JSON.parse(this.fileData.otherDocuments)
        this.isUpload = false
        this.isFile = true
        if (this.roleType == 2) {
          this.remarkReason = this.fileData.remark
        }
      } else {
        if (this.roleType == 2) {
          this.userId = this.$route.query.id || this.quesNaireData.createUserId
        }
        const { data } = await findFileInfo(this.userId)
        if (data.code != 0) return
        
        this.fileData = JSON.parse(JSON.stringify(data.fileManagement))
        console.log(this.fileData);
        if (this.fileData == null) {
          if (this.roleType == 2) {
            this.isUpload = false  //上传样式
            this.isFile = true  // 上传是否禁止点击
            this.isShowFile = true
          } else if (this.roleType == 3) {
            this.isFile = false
            this.isUpload = true
            this.isEdit1 = false
            this.isEdit2 = true
            this.isEdit = false
            this.isSave = false
          }
        }
        else {
          this.fileList1 = JSON.parse(this.fileData.businessLicense)
          this.fileList2 = JSON.parse(this.fileData.complianceDocuments)
          this.fileList3 = JSON.parse(this.fileData.executiveQualification)
          this.fileList4 = JSON.parse(this.fileData.otherDocuments)
          
          this.fileParams.id = data.fileManagement.id
          if (this.fileData.approveStatus == 5) {
            this.isFile = true
            this.isUpload = false
            this.isEdit1 = true
            this.isEdit2 = false
            this.isEdit = false
            this.isSave = true
          } else if (this.fileData.approveStatus == 1 || this.fileData.approveStatus == 2) {
            this.isFile = true
            this.isUpload = false
            this.isEdit1 = false
            this.isEdit2 = false
            this.isEdit = true
            this.isSave = true
          }
        }
      }


    },
    editFileInfo() {
      this.isFile = false
      this.isUpload = true
      this.isEdit1 = false
      this.isEdit2 = true
      this.isSave = false
      this.isEdit = true
    },
    async comSubmit() {
      this.fileParams.businessLicense = JSON.stringify(this.fileList1)
      this.fileParams.complianceDocuments = JSON.stringify(this.fileList2)
      this.fileParams.executiveQualification = JSON.stringify(this.fileList3)
      this.fileParams.otherDocuments = JSON.stringify(this.fileList4)
      const { data } = await addFileInfo(this.fileParams)
      if (data.code != 0) return
      this.$refs.reasonDialog.submitVisible = false
      this.getFileInfo()

    },
    saveFileInfo() {
      this.fileParams.remark = ''
      if (this.fileData == null) {
        this.comSubmit()
      } else {
        this.$refs.reasonDialog.submitVisible = true
      }

    },

    async handleFileSuccess1(file, fileList) {
      if (fileList.status == 'success') {
        this.fileList1.push({
          'name': fileList.name,
          'url': fileList.response.fileUrl
        })
      }
    },
    handleRemove1(file) {
      const filePath = file.url
      // //使用findIndex来查找符合条件的索引
      const index = this.fileList1.findIndex(item => item.url === filePath)
      // //移除索引对应的图片
      this.fileList1.splice(index, 1)
    },
    handleRemove2(file) {
      const filePath = file.url
      // //使用findIndex来查找符合条件的索引
      const index = this.fileList2.findIndex(item => item.url === filePath)
      // //移除索引对应的图片
      this.fileList2.splice(index, 1)

    },
    handleRemove3(file) {
      const filePath = file.url
      // //使用findIndex来查找符合条件的索引
      const index = this.fileList3.findIndex(item => item.url === filePath)
      // //移除索引对应的图片
      this.fileList3.splice(index, 1)

    },
    handleRemove4(file) {
      const filePath = file.url
      // //使用findIndex来查找符合条件的索引
      const index = this.fileList4.findIndex(item => item.url === filePath)
      // //移除索引对应的图片
      this.fileList4.splice(index, 1)
    },
    async handleFileSuccess2(file, fileList) {
      if (fileList.status == 'success') {
        this.fileList2.push({
          'name': fileList.name,
          'url': fileList.response.fileUrl
        })
      }
    },
    async handleFileSuccess3(file, fileList) {
      if (fileList.status == 'success') {
        this.fileList3.push({
          'name': fileList.name,
          'url': fileList.response.fileUrl
        })
      }

    },
    async handleFileSuccess4(file, fileList) {
      if (fileList.status == 'success') {
        this.fileList4.push({
          'name': fileList.name,
          'url': fileList.response.fileUrl
        })
      }
    },

  },
  components: {
    ExamineDialog,
    BackDialog,
    ReasonDialog
  }
}
</script>
<style lang='less' scoped>
#fileManagement {
  .fileTips {
    display: inline-block;
    margin-left: 50px;
    position: relative;
    font-weight: 400;
    font-size: 14px;
    color: #FF3399;
    
  }
  .no-file-result {
    margin: 50px;
    font-size: 18px;
    text-align: center;
    line-height: 43px;
    color: #333;
    img{
      vertical-align: middle;
      margin-right: 20px;
    }
  }
  .fileTips::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -4%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ffbf00;
  }
  .fileDivider {
    margin-top: 10px !important;
  }
  .fileEdit {
    text-align: right;
    .editFile {
      line-height: 34px;
      padding: 0 20px;
      height: 36px;
      border-radius: 18px;
      color: #999;
    }
    .submitFile {
      height: 36px;
      line-height: 36px;
      padding: 0 20px;
      border-radius: 18px;
      color: #999;
    }
    .edit {
      background-image: linear-gradient(-45deg, #0566cc 0%, #3793f4 100%);
      color: #fff;
    }
  }
  .statusStyle {
    width: 40%;
    height: 36px;
    display: flex;
    align-items: center;
    // list-style: 36px;
    background-color: #dce8f5;
    border-radius: 5px;
    border: solid 1px #0e6fd0;
    margin-bottom: 20px;
    color: #333333;
    font-size: 16px;
    .fileIcon:before {
      display: inline-block;
      color: #0066cb;
      font-size: 16px;
      margin: 0 8px 0 15px;
    }
  }
  /deep/ .fileUpload {
    margin-bottom: 25px;
    .name {
      color: #333333;
      font-weight: 550;
    }
    .upload {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 134px;
      height: 36px;
      border-radius: 18px;
      font-size: 16px;
      margin-right: 15px;
      border: solid 1px #ccc;
      color: #999;
      // cursor: not-allowed;
    }
    .escUpload {
      border: solid 1px #0566cc;
      color: #0066cc;
      cursor: pointer;
    }
    .el-upload__tip {
      margin-top: 0;
    }
    .el-upload-list__item {
      width: 35%;
    }
    .el-upload-list__item {
      width: 40% !important;
    }
    .uploadNone {
      .el-upload {
        display: none;
      }
      .el-icon-circle-check:before {
        content: '';
      }
      .example {
        display: none;
      }
      .el-upload-list__item-name {
        position: absolute;
        top: -15px;
        left: 0;
      }
    }
  }
  .adminEdit {
    margin-left: 15px;
    vertical-align: middle;
    cursor: pointer;
  }
  .apply-change-tip{
    text-align: center;
    font-size: 18px;
    padding: 70px 0 180px;
    img{
      vertical-align: middle;
      margin-right: 20px;
    }
  }
}
.required-tips{
  color: #999;
  font-size: 14px;
  font-weight: normal;
}
</style>